import { BreadcrumbRoute } from '@/models/types'
import { defineStore } from 'pinia'
import { RouteRecordRaw } from 'vue-router'
import storage from '@/utils/storage'
import { normalRoutes, roleRoutes } from '@/configs/route.config'
import { dataToPromiseTree, filterAsyncRouter } from '@/utils'
import { LoginDto, MenuDto, UserDto } from '@/models/dtos'
import { ChangePswArgs, LoginArgs } from '@/models/args'
import { AccountClass, MenuClass } from '@/apis'

const accountApi = new AccountClass()
const menuApi = new MenuClass()
export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: '',
      userInfo: null as UserDto | null,
      menus: <Array<MenuDto>>[],
      routers: <Array<RouteRecordRaw>>[],
      roleRouters: <Array<RouteRecordRaw>>[],
      breadcrumbRoutes: <Array<BreadcrumbRoute>>[]
    }
  },
  getters: {},
  actions: {
    

    setUserInfo(user: UserDto){
      this.$patch({
        userInfo: user
      })
    },

    setToken(token: string){
      if(token){
        this.token = token
        storage.set('BEARER_TOKEN', token)
      }
    },

    onLogout(){
      return new Promise<number>((resolve, reject) => {
        accountApi.logout().then(() => {

          storage.remove('BEARER_TOKEN')
          
          resolve(1)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onLogin(args: LoginArgs){
      return new Promise<LoginDto>((resolve, reject) => {
        accountApi.login(args).then((resp) => {

          this.setToken(resp.token)
          
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onGetUserInfo(){
      return new Promise<UserDto>((resolve, reject) => {
        accountApi.info().then((resp) => {
          this.setUserInfo(resp)
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onChangePsw(args: ChangePswArgs){
      return new Promise<number>((resolve, reject) => {
        accountApi.changePsw(args).then((resp) => {
          resolve(resp)
        }).catch(e => {
          reject(e)
        })
      })
    },

    onGetMenus(){
      return new Promise<MenuDto[]>((resolve, reject) => {
        menuApi.menus().then((res) => {
          if(res.length === 0){
            res = [
              {
                id: -1,
                name: '首页',
                sign: 'index',
                roleId: 0,
                type: 0,
                parentId: 0,
                sort: 0,
                remark: 'string',
                actions: []
              }
            ]
          }

          this.menus = res
          const pros = dataToPromiseTree(res, 0)
          resolve(pros)
        }).catch(e => {
          reject(e)
        })
      })
    },

    GenerateRoutes(permissionMenus: MenuDto[]){
      return new Promise((resolve) => {
        const menus = permissionMenus

        const accessedRouters = filterAsyncRouter(roleRoutes, menus)

        this.roleRouters = accessedRouters
        this.routers = normalRoutes.concat(accessedRouters)
        resolve(accessedRouters)
      })
    }
  }
})